import React from "react";

const ToolTips = ({ children, text, position = "top" }) => {
  const positionClass =
    position === "top"
      ? "-top-8 left-1/2 -translate-x-1/2"
      : position === "bottom"
      ? "top-full mt-2 left-1/2 -translate-x-1/2"
      : position === "left"
      ? "right-full mr-2 top-1/2 -translate-y-1/2"
      : "left-full ml-2 top-1/2 -translate-y-1/2";

  return (
    <div className="font-main text-md relative flex justify-center w-full group z-50">
      {children}
      <div
        className={`absolute font-main text-md whitespace-nowrap px-2 py-1 text-white bg-gray-800 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${positionClass}`}
      >
        {text}
      </div>
    </div>
  );
};

export default ToolTips;
